var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomEyeSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-606 6588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye-solid",
    d: "M21.868,70.776A12.25,12.25,0,0,0,11,64,12.252,12.252,0,0,0,.133,70.776a1.236,1.236,0,0,0,0,1.115A12.25,12.25,0,0,0,11,78.667a12.252,12.252,0,0,0,10.867-6.776,1.236,1.236,0,0,0,0-1.115ZM11,76.833a5.5,5.5,0,1,1,5.5-5.5A5.5,5.5,0,0,1,11,76.833Zm0-9.167a3.64,3.64,0,0,0-.967.145,1.828,1.828,0,0,1-2.555,2.555A3.658,3.658,0,1,0,11,67.667Z",
    transform: "translate(606.999 -6647.333)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomEyeSolid);
export default __webpack_public_path__ + "static/media/custom-eye-solid.7198e2229348903395d52aed99a38074.svg";
export { ForwardRef as ReactComponent };